/**
 * Stable opener ids mapped to `connection.say-hi-opener-*` i18n keys.
 *
 * Order is display order, and the dialog defaults its selection + prefilled text to the
 * first entry — so `working-on` ("Excited to connect!…") leads and is pre-selected.
 */
export const SAY_HI_OPENER_KEYS = ['working-on', 'medium', 'portfolio'] as const;

export type SayHiOpenerKey = (typeof SAY_HI_OPENER_KEYS)[number];
